import React from 'react';

import { Card, Spin, Typography } from 'antd';

interface IProps {
  title: string;
  children: React.ReactNode;
  loading?: boolean;
  action?: React.ReactNode;
}

export function FormContent(props: IProps) {
  const { children, loading = false, title, action } = props;

  return (
    <Card
      size='small'
      title={
        title ? (
          <Typography.Text strong className='text-base'>
            {title}
          </Typography.Text>
        ) : undefined
      }
      extra={action}
      classNames={{ body: 'p-4' }}
    >
      <Spin spinning={loading}>
        <div className={loading ? 'pointer-events-none opacity-30' : undefined}>{children}</div>
      </Spin>
    </Card>
  );
}
